var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule"},[_c('div',{staticClass:"title"},[_vm._v("活动规则")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.rule)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }